import React, { useRef, useState } from 'react';
import { useOnClickOutside } from '../../../../../../common/hooks/useOnClickOutside';
import { basePath } from '../../../../../../services/utils';
import * as SC from './Dropdown.styles';
import PropTypes from 'prop-types';

const Dropdown = ({ options, selectedOption, onChange, defaultText, hasColorLine, disabled }) => {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef();
    useOnClickOutside(dropdownRef, () => setIsOpen(false));

    const selectedOptionName = options.find(el => el.key === selectedOption)?.itemLabel ?? defaultText;
    const selectedOptionColor = options.find(el => el.key === selectedOption)?.color;
    const openIndicatorArrows = [`${basePath}/visuals/Icon_contry_down.png`, `${basePath}/visuals/Icon_contry_up.png`];

    const onChangeHandler = key => {
        onChange(key);
        setIsOpen(false);
    };

    return (
        <SC.DropdownWrapper data-testid={'Dropdown-Wrapper'} ref={dropdownRef}>
            <SC.DropdownHeader
                data-testid={'Dropdown-Header'}
                onClick={() => setIsOpen(!isOpen)}
                isOpen={isOpen}
                legendColor={selectedOptionColor}
                disabled={disabled}
            >
                {isOpen ? (
                    <div>{defaultText}</div>
                ) : (
                    <div data-testid={'Dropdown-OptionName'}>
                        {hasColorLine && <span />}
                        {selectedOptionName}
                    </div>
                )}
                <img src={openIndicatorArrows[+isOpen]} />
            </SC.DropdownHeader>
            {isOpen && (
                <SC.DropdownMenu data-testid={'Dropdown-Menu'}>
                    <SC.DropdownItemsWrapper>
                        {options.map(el => (
                            <SC.DropdownItem
                                data-testid={'Dropdown-Item'}
                                key={el.key}
                                legendColor={el.color}
                                onClick={() => onChangeHandler(el.key)}
                            >
                                {hasColorLine && <span />}
                                {el.itemLabel}
                            </SC.DropdownItem>
                        ))}
                    </SC.DropdownItemsWrapper>
                </SC.DropdownMenu>
            )}
        </SC.DropdownWrapper>
    );
};

const OptionsShape = PropTypes.shape({
    key: PropTypes.number.isRequired,
    color: PropTypes.string,
    itemLabel: PropTypes.string.isRequired,
    isChecked: PropTypes.bool,
});

Dropdown.propTypes = {
    options: PropTypes.arrayOf(OptionsShape),
    selectedOption: PropTypes.number,
    onChange: PropTypes.func.isRequired,
    defaultText: PropTypes.string.isRequired,
    hasColorLine: PropTypes.bool.isRequired,
    disabled: PropTypes.bool,
};
Dropdown.defaultProps = {
    options: [],
    selectedOption: null,
    hasColorLine: true,
    disabled: false,
};

export default Dropdown;
